import { useMemo } from 'react'

import { Link, Tooltip } from '@mui/material'
import { Button, useTranslate } from 'react-admin'
import { YoutubeChannel } from '../types/YoutubeChannel'
import { YOUTUBE_OWNERS_IDS } from './../helpers/constants'
import { LXYoutubeIcon } from './LXYoutubeIcon'

type LXYoutubeLinkProps = {
  youtubeAssetId?: string
  cms?: YoutubeChannel['cms']
}
export const LXYoutubeLink = ({ youtubeAssetId, cms }: LXYoutubeLinkProps) => {
  const translate = useTranslate()
  const url = useMemo(
    () =>
      `https://studio.youtube.com/asset/${youtubeAssetId}/metadata/overview?o=${
        YOUTUBE_OWNERS_IDS[cms ?? '']
      }`,
    [youtubeAssetId, cms],
  )

  const isDisabled = useMemo(
    () => typeof cms === 'undefined' || typeof youtubeAssetId === 'undefined',
    [cms, youtubeAssetId],
  )

  const button = useMemo(
    () => (
      <Button label={translate('pages.artworks.linkToYouTubeStudio')} disabled={isDisabled}>
        <LXYoutubeIcon />
      </Button>
    ),
    [translate, isDisabled],
  )

  return isDisabled ? (
    <Tooltip title={translate('pages.artworks.youtubeChannelUnavailable')} placement="top" arrow>
      <span>{button}</span>
    </Tooltip>
  ) : (
    <Link href={url} target="_blank">
      {button}
    </Link>
  )
}
